import {
	Component, Input, ViewChild, OnInit, OnDestroy, AfterViewInit, OnChanges, SimpleChanges, ElementRef, ChangeDetectionStrategy, ChangeDetectorRef, EventEmitter, Output
} from '@angular/core';
import { Subscription } from 'rxjs/Rx';
import { TopoMapControl, TopoMapControlListener } from '../../topology/TopoMapControl';
import { MonitorState } from '../../dtos/topology/DeviceConnection';
import { DeviceNode, DeviceState } from '../../dtos/topology/DeviceNode';
import { TopoImageLibrary } from '../../topology/TopoImageLibrary';
import { MapConversionService } from '../../services/mapconversion.service';
import { TopoMap, DisplayEdge } from '../../dtos/topology/TopoMap';
import { DeviceLink, DeviceLinkMember } from '../../dtos/topology/DeviceLink';
import { DeviceLinkEdge } from '../../dtos/topology/DeviceLinkEdge';
import * as core from 'DiscoveryEngine.TS/Topology';
import { DeviceDetailsComponent, InfoSetsComponent } from 'infosets';
import { LinkDetailsComponent } from '../linkdetails/linkdetails.component';
import { NavigationService, NetFacadeService } from 'netview';
import { DiscResultsService, ExportToPrtgOptions, ExportToPrtgMapOptions } from 'discovery';
import { IdentityService } from 'identity';
import { MessageService } from 'base';
import { DisplayDeviceGroupContainerDto, DisplayDeviceGroupDto, GetMapDeviceStateResultDto, MapDeviceStateDto, MapIfEntryStateDto } from 'UvExplorerServer.Dtos.TS/Session';
import { DeviceDto } from 'UvExplorerServer.Dtos.TS/Session';
import { LayoutSettings } from 'DiscoveryEngine.TS/Topology';
import { MonitorService } from 'monitor';
import { NetViewDto } from 'UvExplorerServer.Dtos.TS/NetViews';
import { MenuItem } from 'primeng/api';
import { ContextMenu } from 'primeng/contextmenu';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { ToolsService } from 'tools';
import { TopoMapConfigurationService } from 'configuration/services/topo-map-configuration.service';
import { TopoMapConfigurationWebService } from 'configuration/services/topo-map-configuration.web.service';
import { UserSettingsService } from 'main/services/user-settings.service';
import { Theme } from 'main/enums/theme.enum';


@Component({
	selector: 'layer2map',
	templateUrl: './layer2map.component.html',
	styleUrls: ['./layer2map.component.scss'],
	providers: [TopoMapConfigurationService, TopoMapConfigurationWebService],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class Layer2MapComponent implements OnInit, OnDestroy, AfterViewInit, OnChanges, TopoMapControlListener {

	public readonly UseOffCanvas: boolean = false;

	private static readonly BASE_LUCID_OAUTH_REDIRECT_URL = "https://api.uvexplorer.com/uvxserver/lucid-oauth-callback";

	@ViewChild(ContextMenu, { static: true })
	private contextMenu: ContextMenu;

	public items: MenuItem[];
	private mapItems: MenuItem[];
	private contextMenuTargets: any[];
	private isEditable = false;

	public selectedDeviceGroup: DisplayDeviceGroupDto;
	public get hasSelectedDeviceGroup(): boolean {
		return !!this.selectedDeviceGroup;
	}
	public setSelectedDeviceGroup(ddg: DisplayDeviceGroupDto): void {
		this.selectedDeviceGroup = ddg;
		this.selectedDevice = null;
		this.selectedLinks = [];
		this.updateUpButton();
	}

	public selectedDevice: DeviceDto;
	public get hasSelectedDevice(): boolean {
		return !!this.selectedDevice;
	}

	public selectedLinks: DeviceLink[];
	public get hasSelectedLinks(): boolean {
		return (!!this.selectedLinks && this.selectedLinks.length > 0);
	}

	public exportVisible: boolean;
	public exportType: string;
	public exportTitle: string;
	public exportMode: string;

	public lucidConfirmVisible: boolean;
	private lucidUrl: string;

	public layoutSettingsVisible: boolean;
	public layoutSettings: LayoutSettings;

	@Input()
	public selected: boolean;

	@Output()
	public editDeviceGroup: EventEmitter<any>;

	@ViewChild("devicedetails", { static: true })
	public deviceDetails: DeviceDetailsComponent;

	@ViewChild("infosets", { static: true })
	public infoSets: InfoSetsComponent;

	@ViewChild("linkdetails", { static: true })
	public linkDetails: LinkDetailsComponent;

	@ViewChild('detailsOffCanvas')
	public detailsOffCanvas: any;

	private topoMapLoadedSub: Subscription;

	private topoMapControl: TopoMapControl;

	private destroyed: boolean;
	private eventsInterval: number;
	private timerId: any;

	// Used to force link details dialog to redraw when monitor statuses change
	public version: number;

	private devicesChangedSub: Subscription;

	public mapSearchVisible: boolean;

	constructor(private element: ElementRef,
		private mapConversionService: MapConversionService,
		private changeDetector: ChangeDetectorRef,
		private discResultsService: DiscResultsService,
		private identityService: IdentityService,
		private navService: NavigationService,
		private messageService: MessageService,
		private monService: MonitorService,
		private netFacadeService: NetFacadeService,
		private offcanvasService: NgbOffcanvas,
		private userSettingsService: UserSettingsService,
		private toolsService: ToolsService,
	) {
		this.selectedDeviceGroup = null;
		this.selectedDevice = null;
		this.selectedLinks = [];
		this.editDeviceGroup = new EventEmitter<any>();

		this.exportVisible = false;
		this.exportType = "";
		this.exportTitle = "";
		this.exportMode = "";

		this.lucidConfirmVisible = false;
		this.lucidUrl = "";

		this.layoutSettingsVisible = false;
		this.layoutSettings = new LayoutSettings();

		this.topoMapLoadedSub = discResultsService.onTopoMapLoaded.subscribe(
			(map: TopoMap) => {
				this.setMap(map);
				this.retrieveDeviceStates(false);
			},
			(error?) => {
				console.log("Map Load Failed");
				this.setMap(null);
			});

		this.items = [];
		this.mapItems = [];
		this.contextMenuTargets = [];

		this.destroyed = false;
		this.eventsInterval = 0;
		this.timerId = undefined;

		this.version = 0;
		this.mapSearchVisible = false;

		this.devicesChangedSub = toolsService.devicesChanged.subscribe((changedDeviceGuids: string[]) => {
			if (this.hasSelectedDevice && !!this.selectedDevice.deviceGuid) {
				if (changedDeviceGuids.includes(this.selectedDevice.deviceGuid)) {

					if (!!this.infoSets || !!this.deviceDetails) {
						let sessionGuid = this.identityService.sessionGuid;
						let netViewGuid = this.navService.location.netViewGuid;
						let agentGuid = this.navService.location.agentGuid;
						let schedDiscGuid = this.navService.location.schedDiscGuid;
						let schedDiscRsltGuid = this.navService.location.schedDiscRsltGuid;
						let deviceGuid = this.selectedDevice.deviceGuid;

						this.discResultsService.getDeviceView(sessionGuid, netViewGuid, agentGuid,
							schedDiscGuid, schedDiscRsltGuid, deviceGuid).subscribe(
								(result: DeviceDto) => {
									if (this.UseOffCanvas) {
										this.infoSets.patchData(result);
									}
									else {
										this.deviceDetails.patchData(result);
									}

									this.changeDetector.markForCheck();
								},
								(error?) => {
									this.messageService.displayErrorMessage("Could not retrieve the selected device");
								});
					}
				}
			}
		});
	}

	public get map(): TopoMap {
		return this.topoMapControl?.getMap() ?? null;
	}

	private setMapTimerId: any = undefined;
	private mapToLoadWhenImagesReady: TopoMap = null;

	private setMap(map: TopoMap): void {
		if (!map) {
			map = this.mapConversionService.convertMap(new core.TopoMap(), new core.DrawSettings());
		}

		if (TopoImageLibrary.isLoaded) {
			if (this.setMapTimerId !== undefined) {
				clearTimeout(this.setMapTimerId);
				this.setMapTimerId = undefined;
			}

			this.mapToLoadWhenImagesReady = null;

			this.isEditable = (map.layoutSettings.layoutType == core.LayoutType.Manual);

			this.items = [];

			this.mapItems = [];
			if (this.isEditable) {
				this.mapItems = [
					...this.mapItems,
					// { label: 'Add Devices...', command: () => this.onAddDevicesRequested() },
					// {
					// 	label: 'Add Connected...', items: [
					// 		{ label: 'Network Devices', command: () => this.addConnectedDevices('NetworkDevice') },
					// 		{ label: 'Servers', command: () => this.addConnectedDevices('Server') },
					// 		{ label: 'Printers', command: () => this.addConnectedDevices('Printer') },
					// 		{ label: 'Workstations', command: () => this.addConnectedDevices('Workstation') },
					// 	]
					// },
					// {
					// 	label: 'Add Associated...', items: [
					// 		{ label: 'Virtual Hosts', command: () => this.addAssociatedDevices('VirtualHost') },
					// 		{ label: 'Virtual Servers', command: () => this.addAssociatedDevices('VirtualServer') },
					// 		{ label: 'Virtual Machines', command: () => this.addAssociatedDevices('Virtual') },
					// 		{ label: 'Wireless APs', command: () => this.addAssociatedDevices('WirelessAp') },
					// 		{ label: 'IP Phones', command: () => this.addAssociatedDevices('IpPhone') },
					// 	]
					// },
					// { separator: true },
					// { label: 'Remove Devices...', command: () => this.onRemoveDevicesRequested([]) },
					// {
					// 	label: 'Remove Connected...', items: [
					// 		{ label: 'Network Devices', command: () => this.removeConnectedDevices('NetworkDevice') },
					// 		{ label: 'Servers', command: () => this.removeConnectedDevices('Server') },
					// 		{ label: 'Printers', command: () => this.removeConnectedDevices('Printer') },
					// 		{ label: 'Workstations', command: () => this.removeConnectedDevices('Workstation') },
					// 	]
					// },
					// {
					// 	label: 'Remove Associated...', items: [
					// 		{ label: 'Virtual Hosts', command: () => this.removeAssociatedDevices('VirtualHost') },
					// 		{ label: 'Virtual Servers', command: () => this.removeAssociatedDevices('VirtualServer') },
					// 		{ label: 'Virtual Machines', command: () => this.removeAssociatedDevices('Virtual') },
					// 		{ label: 'Wireless APs', command: () => this.removeAssociatedDevices('WirelessAp') },
					// 		{ label: 'IP Phones', command: () => this.removeAssociatedDevices('IpPhone') },
					// 	]
					// },
					// { separator: true },
					{ label: 'Layout Map...', command: () => this.startLayoutMap() },
					{ separator: true },
				];
			}
			const hasRoots = (map.layoutSettings.rootNodes?.length ?? 0) > 0;
			this.mapItems = [...this.mapItems,
			{ label: 'Select Assigned Roots', disabled: !hasRoots, command: () => this.selectAssignedRoots() },
			{ separator: true },
			{
				label: 'Export', items: [
					{ label: 'Export to Lucidchart ...', command: () => this.exportToLucid() },
					{ label: 'Export to Visio ...', command: () => this.exportToVisio() },
					{ label: 'Export to PDF ...', command: () => this.exportToPdf() },
					{ label: 'Export to SVG ...', command: () => this.exportToSvg() },
					{ separator: true },
					{ label: 'Export to PRTG ...', command: () => this.exportToPrtg() },
					{ label: 'Export to PRTG Map ...', command: () => this.exportToPrtgMap() },
					{ label: 'Export to PRTG (Data Only) ...', command: () => this.exportToPrtgDataOnly() },
				]
			},
			{ separator: true },
			{ label: 'Edit Device Group...', command: () => this.editDeviceGroup.emit() }
			];

			this.topoMapControl.setMap(map, this.isEditable);

			this.changeDetector.markForCheck();
		}
		else {
			this.mapToLoadWhenImagesReady = map;

			if (this.setMapTimerId === undefined) {
				this.setMapTimerId = setTimeout(() => {
					this.setMapTimerId = undefined;
					if (this.mapToLoadWhenImagesReady) {
						this.setMap(this.mapToLoadWhenImagesReady);
					}
				}, 500);
			}
		}
	}

	private retrieveDeviceStates(showBusy: boolean): void {

		let sessionGuid = this.identityService.sessionGuid;
		let netViewGuid = this.navService.location.netViewGuid;
		let agentGuid = this.navService.location.agentGuid;
		let schedDiscGuid = this.navService.location.schedDiscGuid;
		let schedDiscRsltGuid = this.navService.location.schedDiscRsltGuid;

		let deviceGuids: string[] = this.mapDeviceGuids;
		if (deviceGuids.length > 0) {
			this.monService.getMapDeviceState(sessionGuid, netViewGuid, agentGuid, schedDiscGuid,
				schedDiscRsltGuid, deviceGuids, showBusy).subscribe(
					(result: GetMapDeviceStateResultDto) => {
						if (this.topoMapControl.hasMap()) {
							this.applyDeviceStates(result);
							this.topoMapControl.redraw();
							++this.version;
							this.changeDetector.detectChanges();
						}
					},
					(error) => {
						// Suppress — can occur during network transitions
					});
		}
	}

	private applyDeviceStates(mapDeviceStates: GetMapDeviceStateResultDto): void {

		let deviceStateMap = {};
		mapDeviceStates.entries.forEach((entry: MapDeviceStateDto) => {
			deviceStateMap[entry.deviceGuid] = entry.deviceState;
		});

		let ifEntryStateMap = {};
		mapDeviceStates.ifEntries.forEach((entry: MapIfEntryStateDto) => {
			let deviceIfEntryStateMap = ifEntryStateMap[entry.deviceGuid];
			if (deviceIfEntryStateMap === undefined) {
				deviceIfEntryStateMap = {};
				ifEntryStateMap[entry.deviceGuid] = deviceIfEntryStateMap;
			}
			deviceIfEntryStateMap[entry.ifIndex] = entry.monitorState;
		});

		let map: TopoMap = this.topoMapControl.getMap();

		map.deviceNodes.forEach((devNode: DeviceNode) => {
			devNode.status = this.findDeviceState(deviceStateMap, devNode.deviceGuid);
		});

		map.deviceLinks.forEach((devLink: DeviceLink) => {
			let worstMonState = MonitorState.NoData;
			devLink.linkEdges.forEach((linkEdge: DeviceLinkEdge) => {
				let localDevGuid = linkEdge.localConnection.deviceGuid;
				let localDevIfIndex = linkEdge.localConnection.deviceIfIndex;
				let localMonState = this.findIfEntryState(ifEntryStateMap, localDevGuid, localDevIfIndex);
				linkEdge.localConnection.monitorState = localMonState;
				if (this.monitorStateRank(localMonState) > this.monitorStateRank(worstMonState)) {
					worstMonState = localMonState;
				}

				let remoteDevGuid = linkEdge.remoteConnection.deviceGuid;
				let remoteDevIfIndex = linkEdge.remoteConnection.deviceIfIndex;
				let remoteMonState = this.findIfEntryState(ifEntryStateMap, remoteDevGuid, remoteDevIfIndex);
				linkEdge.remoteConnection.monitorState = remoteMonState;
				if (this.monitorStateRank(remoteMonState) > this.monitorStateRank(worstMonState)) {
					worstMonState = remoteMonState;
				}
			});

			devLink.monitorState = worstMonState;

			devLink.linkMembers.forEach((linkMember: DeviceLinkMember) => {
				linkMember.monitorState = this.findIfEntryState(ifEntryStateMap, linkMember.deviceGuid, linkMember.ifIndex);
				linkMember.connectedMonitorState = this.findIfEntryState(ifEntryStateMap, linkMember.connectedDeviceGuid, linkMember.connectedIfIndex);
			});
		});

		map.displayEdges.forEach((dispEdge: DisplayEdge) => {
			let worstMonState = MonitorState.NoData;
			dispEdge.deviceLinkEdges.forEach((devLinkEdge: DeviceLinkEdge) => {
				if (devLinkEdge.localConnection) {
					let localMonState = devLinkEdge.localConnection.monitorState;
					if (this.monitorStateRank(localMonState) > this.monitorStateRank(worstMonState)) {
						worstMonState = localMonState;
					}
				}
				if (devLinkEdge.remoteConnection) {
					let remoteMonState = devLinkEdge.remoteConnection.monitorState;
					if (this.monitorStateRank(remoteMonState) > this.monitorStateRank(worstMonState)) {
						worstMonState = remoteMonState;
					}
				}
			});

			dispEdge.monitorState = worstMonState;
			dispEdge.clearEffectiveDrawSettings();
		});
	}

	private findDeviceState(deviceStateMap: {}, deviceGuid: string): DeviceState {
		if (!!deviceGuid && deviceStateMap[deviceGuid] !== undefined) {
			return deviceStateMap[deviceGuid];
		}
		return DeviceState.NoData;
	}

	private findIfEntryState(ifEntryStateMap: object, deviceGuid: string, ifIndex: number): MonitorState {
		if (!!deviceGuid && ifIndex >= 0) {
			let deviceIfEntryStateMap = ifEntryStateMap[deviceGuid];
			if (deviceIfEntryStateMap !== undefined && deviceIfEntryStateMap[ifIndex] !== undefined) {
				return deviceIfEntryStateMap[ifIndex];
			}
		}
		return MonitorState.NoData;
	}

	private monitorStateRank(monState: MonitorState): number {
		switch (monState) {
			case MonitorState.NoData: return 100;
			case MonitorState.Information: return 200;
			case MonitorState.Up: return 300;
			case MonitorState.Paused: return 400;
			case MonitorState.Unknown: return 500;
			case MonitorState.Warning: return 600;
			case MonitorState.Down: return 700;
			default:
				console.assert(false);
				return -1;
		}
	}

	private get mapDeviceGuids(): string[] {
		let result: string[] = [];
		if (!!this.topoMapControl && this.topoMapControl.hasMap()) {
			this.topoMapControl.getMap().deviceNodes.forEach((devNode: DeviceNode) => {
				if (devNode.deviceGuid) result.push(devNode.deviceGuid);
			});
		}
		return result;
	}

	public ngOnInit(): void {
		return;
	}

	public ngOnChanges(changes: SimpleChanges): void {
		if (this.destroyed) return;

		if (changes["selected"]) {
			this.stopTimer();
			if (this.selected && this.navService.isNetworkLoaded) {
				this.retrieveDeviceStates(false);
				this.startTimer();
			}
		}
	}

	public ngOnDestroy(): void {
		this.destroyed = true;
		this.stopTimer();

		if (this.topoMapLoadedSub) {
			this.topoMapLoadedSub.unsubscribe();
			this.topoMapLoadedSub = undefined;
		}
		if (this.devicesChangedSub) {
			this.devicesChangedSub.unsubscribe();
			this.devicesChangedSub = undefined;
		}
	}

	private setEventsInterval(): void {
		this.eventsInterval = 0;
		let netViewGuid = this.navService.location.netViewGuid;
		let network: NetViewDto = this.netFacadeService.findNetwork(netViewGuid);
		if (network) {
			this.eventsInterval = network.EventsInterval;
		}
		else {
			this.messageService.displayErrorMessage("Could not set events interval");
		}
	}

	private startTimer(): void {
		this.setEventsInterval();
		if (!this.timerId && this.selected && this.eventsInterval > 0) {
			let timeoutMillis = this.eventsInterval * 1000;
			this.timerId = setInterval(() => {
				this.retrieveDeviceStates(false);
			}, timeoutMillis);
		}
	}

	private stopTimer(): void {
		if (this.timerId) {
			clearInterval(this.timerId);
			this.timerId = undefined;
		}
	}

	public ngAfterViewInit(): void {
		let rootElem = <HTMLDivElement>this.element.nativeElement;
		let mapContainer = <HTMLDivElement>rootElem.querySelector('.layer2map-map-container');

		this.topoMapControl = new TopoMapControl(mapContainer, this, {
			isDarkTheme: /*this.userSettingsService?.CurrentTheme === Theme.Dark*/ false,
		});
		this.updateUpButton();
	}

	// ── TopoMapControlListener ───────────────────────────────────────────────

	public onDeviceDoubleClick(deviceGuid: string): void {
		let sessionGuid = this.identityService.sessionGuid;
		let netViewGuid = this.navService.location.netViewGuid;
		let agentGuid = this.navService.location.agentGuid;
		let schedDiscGuid = this.navService.location.schedDiscGuid;
		let schedDiscRsltGuid = this.navService.location.schedDiscRsltGuid;

		this.discResultsService.getDeviceView(sessionGuid, netViewGuid, agentGuid,
			schedDiscGuid, schedDiscRsltGuid, deviceGuid).subscribe(
				(result: DeviceDto) => {
					this.selectedDevice = result;

					if (this.UseOffCanvas) {
						this.openOffcanvas();
					}
					else {
						this.deviceDetails.show();
					}

					this.changeDetector.markForCheck();
				},
				(error?) => {
					this.messageService.displayErrorMessage("Could not retrieve the selected device");
				});
	}

	public onDeviceGroupDoubleClick(deviceGroupGuid: string): void {
		this.discResultsService.setSelectedDeviceGroup(deviceGroupGuid);
	}

	public onLinkDoubleClick(links: DeviceLink[]): void {
		this.selectedLinks = links;
		this.linkDetails.show();
		this.changeDetector.markForCheck();
	}

	public onMapDoubleClick(): void {
		this.editDeviceGroup.emit();
	}

	public onMoveNode(nodeId: number, newX: number, newY: number): void {

		let sessionGuid = this.identityService.sessionGuid;
		let netViewGuid = this.navService.location.netViewGuid;
		let agentGuid = this.navService.location.agentGuid;
		let schedDiscGuid = this.navService.location.schedDiscGuid;
		let schedDiscRsltGuid = this.navService.location.schedDiscRsltGuid;
		let vdgGuid = this.selectedDeviceGroup.VdgGuid;

		let errorMessage = "Save failed! Another user might be editing this map. Reload this page and try again.";
		this.discResultsService.moveTopoMapNode(sessionGuid, netViewGuid, agentGuid,
			schedDiscGuid, schedDiscRsltGuid, vdgGuid, nodeId, newX, newY).subscribe(
				(result: boolean) => {
					if (!result) this.messageService.displayErrorMessage(errorMessage);
				},
				(error) => {
					this.messageService.displayErrorMessage(errorMessage);
				});
	}

	public onContextMenu(targetType: string, targets: any[], ev: MouseEvent): void {
		this.contextMenuTargets = targets;
		if (targetType === 'device') {
			this.items = this.buildDeviceMenu(targets as DeviceNode[]);
		} else if (targetType === 'link') {
			this.items = this.buildLinkMenu(targets as DeviceLink[]);
		} else {
			this.items = this.mapItems;
		}
		this.changeDetector.markForCheck();
		this.contextMenu.show(ev);
	}

	private buildDeviceMenu(nodes: DeviceNode[]): MenuItem[] {
		const node = nodes[0];
		const items: MenuItem[] = [];

		// ── Device info ──────────────────────────────────────────────────────────
		items.push({ label: 'Device Properties...', command: () => this.showDeviceProperties(node.deviceGuid) });
		items.push({ separator: true });

		// // ── Integrations ─────────────────────────────────────────────────────────
		// items.push({
		// 	label: 'Show in...', items: [
		// 		{ label: 'Show in AssetPanda...', command: () => this.showInIntegration('assetpanda', node.deviceGuid) },
		// 		{ label: 'Show in HaloITSM...', command: () => this.showInIntegration('halo', node.deviceGuid) },
		// 		{ label: 'Show in Hudu...', command: () => this.showInIntegration('hudu', node.deviceGuid) },
		// 		{ label: 'Show in ITGlue...', command: () => this.showInIntegration('itglue', node.deviceGuid) },
		// 		{ label: 'Show in Lansweeper...', command: () => this.showInIntegration('lansweeper', node.deviceGuid) },
		// 		{ label: 'Show in PRTG...', command: () => this.showInIntegration('prtg', node.deviceGuid) },
		// 		{ label: 'Show in ServiceNow...', command: () => this.showInIntegration('servicenow', node.deviceGuid) },
		// 		{ label: 'Show in NinjaOne\u00ae...', command: () => this.showInIntegration('ninjaone', node.deviceGuid) },
		// 	]
		// });
		// items.push({ separator: true });

		// // ── Manual link ──────────────────────────────────────────────────────────
		// const linkLabel = nodes.length >= 2 ? 'Link Selected...' : 'Link To...';
		// items.push({ label: linkLabel, command: () => this.linkDevices(nodes) });
		// items.push({ separator: true });

		// ── Layout (editable maps only) ──────────────────────────────────────────
		items.push({ label: 'Set As Root', command: () => this.setAsRoot() });
		items.push({ label: 'Auto-Select Root', command: () => this.autoSelectRoot() });
		// if (this.isEditable) {
		// 	items.push({ label: 'Layout Children...', command: () => this.layoutChildren() });
		// }

		// // ── Membership (editable maps only) ─────────────────────────────────────
		// if (this.isEditable) {
		// 	items.push({ separator: true });
		// 	items.push({ label: 'Remove Selected', command: () => this.removeSelectedDevices(nodes) });
		// }

		return items;
	}

	private buildLinkMenu(links: DeviceLink[]): MenuItem[] {
		const hasManualLink = links.some(l => l.linkType === 'Manual');
		const items: MenuItem[] = [];
		// if (hasManualLink) {
		// 	items.push({ label: 'Un-Link', command: () => this.unlinkDevices(links) });
		// }
		items.push({ label: 'Link Properties...', command: () => this.showLinkProperties(links) });
		return items;
	}

	public onSearchRequested(): void {
		this.mapSearchVisible = true;
		this.changeDetector.markForCheck();
	}

	public onNavigateUpRequested(): void {
		const parent = this.findParentGroup();
		if (parent) {
			this.discResultsService.setSelectedDeviceGroup(parent.VdgTagGuid);
		}
	}

	private updateUpButton(): void {
		this.topoMapControl?.setUpButtonEnabled(!!this.findParentGroup());
	}

	private findParentGroup(): DisplayDeviceGroupDto | null {
		const current = this.selectedDeviceGroup;
		if (!current) return null;
		const tree = this.discResultsService?.deviceGroupTree;
		if (!tree?.RootContainer) return null;
		return this._searchParentInContainer(tree.RootContainer, current);
	}

	private _searchParentInContainer(container: DisplayDeviceGroupContainerDto, target: DisplayDeviceGroupDto): DisplayDeviceGroupDto | null {
		for (let i = 0; i < container.Containers.Count; i++) {
			const result = this._searchParentInContainer(container.Containers.Get(i), target);
			if (result) return result;
		}
		for (let i = 0; i < container.Groups.Count; i++) {
			const result = this._searchParentInGroup(container.Groups.Get(i), target);
			if (result) return result;
		}
		return null;
	}

	private _searchParentInGroup(group: DisplayDeviceGroupDto, target: DisplayDeviceGroupDto): DisplayDeviceGroupDto | null {
		if (!group.ChildGroups) return null;
		for (let i = 0; i < group.ChildGroups.Count; i++) {
			const child = group.ChildGroups.Get(i);
			if (child.VdgGuid === target.VdgGuid) return group;
			const result = this._searchParentInGroup(child, target);
			if (result) return result;
		}
		return null;
	}

	// ── Public API used by parent components ─────────────────────────────────

	public setVisible(value: boolean): void {
		this.topoMapControl.setVisible(value);
	}

	public showDeviceOnMap(deviceGuid: string): void {
		this.topoMapControl.showDeviceOnMap(deviceGuid);
	}

	public showDeviceGroupOnMap(deviceGroupGuid: string): void {
		this.topoMapControl.showDeviceGroupOnMap(deviceGroupGuid);
	}

	// ── Export ───────────────────────────────────────────────────────────────

	public exportToLucid(): void {
		this.exportMode = 'advanced';
		this.exportType = "lucid";
		this.exportTitle = "Export Map to Lucidchart";
		this.exportVisible = true;
	}

	public exportToVisio(): void {
		this.exportMode = 'advanced';
		this.exportType = "visio";
		this.exportTitle = "Export Map to Visio";
		this.exportVisible = true;
	}

	public exportToPdf(): void {
		this.exportMode = 'simple';
		this.exportType = "pdf";
		this.exportTitle = "Export Map to PDF";
		this.exportVisible = true;
	}

	public exportToSvg(): void {
		this.exportMode = 'simple';
		this.exportType = "svg";
		this.exportTitle = "Export Map to SVG";
		this.exportVisible = true;
	}

	// ── Export to PRTG (Data Only) ───────────────────────────────────────────

	public exportToPrtgDataOnlyVisible: boolean = false;
	public exportToPrtgDataOnlyNetViewGuid: string = "";

	public exportToPrtgDataOnly(): void {
		// Capture the current netViewGuid so the dialog (which doesn't see the
		// private navService) can pass it to listPrtgSettings.
		this.exportToPrtgDataOnlyNetViewGuid = this.navService.location.netViewGuid;
		this.exportToPrtgDataOnlyVisible = true;
	}

	public onExportToPrtgDataOnly(event: { prtgSettingsGuid: string }): void {
		let sessionGuid = this.identityService.sessionGuid;
		let netViewGuid = this.navService.location.netViewGuid;
		let agentGuid = this.navService.location.agentGuid;
		let schedDiscGuid = this.navService.location.schedDiscGuid;
		let schedDiscRsltGuid = this.navService.location.schedDiscRsltGuid;
		let vdgGuid = this.selectedDeviceGroup.VdgGuid;

		this.messageService.startWork();
		this.discResultsService.exportToPrtgDataOnly(sessionGuid, netViewGuid, agentGuid,
			schedDiscGuid, schedDiscRsltGuid, vdgGuid, event.prtgSettingsGuid).subscribe(
				() => {
					this.messageService.endWork();
					this.messageService.displayInfoMessage("Map data exported to PRTG");
				},
				(error) => {
					this.messageService.endWork();
					this.messageService.displayErrorMessage("Export to PRTG (Data Only) failed");
				});
	}

	// ── Export to PRTG (full export) ─────────────────────────────────────────

	public exportToPrtgVisible: boolean = false;
	public exportToPrtgNetViewGuid: string = "";
	public exportToPrtgDefaultName: string = "";

	public exportToPrtg(): void {
		this.exportToPrtgNetViewGuid = this.navService.location.netViewGuid;
		this.exportToPrtgDefaultName = this.selectedDeviceGroup ? (this.selectedDeviceGroup.Name || "") : "";
		this.exportToPrtgVisible = true;
	}

	public onExportToPrtg(event: { prtgSettingsGuid: string, exportName: string, options: ExportToPrtgOptions }): void {
		let sessionGuid = this.identityService.sessionGuid;
		let netViewGuid = this.navService.location.netViewGuid;
		let agentGuid = this.navService.location.agentGuid;
		let schedDiscGuid = this.navService.location.schedDiscGuid;
		let schedDiscRsltGuid = this.navService.location.schedDiscRsltGuid;
		let vdgGuid = this.selectedDeviceGroup.VdgGuid;

		this.messageService.startWork();
		this.discResultsService.exportToPrtg(sessionGuid, netViewGuid, agentGuid,
			schedDiscGuid, schedDiscRsltGuid, vdgGuid, event.prtgSettingsGuid, event.exportName,
			event.options).subscribe(
				() => {
					this.messageService.endWork();
					this.messageService.displayInfoMessage("Map exported to PRTG");
				},
				(error) => {
					this.messageService.endWork();
					this.messageService.displayErrorMessage("Export to PRTG failed");
				});
	}

	// ── Export to PRTG Map (map-only) ────────────────────────────────────────

	public exportToPrtgMapVisible: boolean = false;
	public exportToPrtgMapNetViewGuid: string = "";
	public exportToPrtgMapDefaultName: string = "";

	public exportToPrtgMap(): void {
		this.exportToPrtgMapNetViewGuid = this.navService.location.netViewGuid;
		this.exportToPrtgMapDefaultName = this.selectedDeviceGroup ? (this.selectedDeviceGroup.Name || "") : "";
		this.exportToPrtgMapVisible = true;
	}

	public onExportToPrtgMap(event: {
		prtgSettingsGuid: string,
		mapName: string,
		prtgTargetGroupId: string,
		options: ExportToPrtgMapOptions
	}): void {
		let sessionGuid = this.identityService.sessionGuid;
		let netViewGuid = this.navService.location.netViewGuid;
		let agentGuid = this.navService.location.agentGuid;
		let schedDiscGuid = this.navService.location.schedDiscGuid;
		let schedDiscRsltGuid = this.navService.location.schedDiscRsltGuid;
		let vdgGuid = this.selectedDeviceGroup.VdgGuid;

		this.messageService.startWork();
		this.discResultsService.exportToPrtgMap(sessionGuid, netViewGuid, agentGuid,
			schedDiscGuid, schedDiscRsltGuid, vdgGuid, event.prtgSettingsGuid, event.mapName,
			event.prtgTargetGroupId, event.options).subscribe(
				() => {
					this.messageService.endWork();
					this.messageService.displayInfoMessage("Map exported to PRTG");
				},
				(error) => {
					this.messageService.endWork();
					this.messageService.displayErrorMessage("Export to PRTG Map failed");
				});
	}

	public onExport(event): void {
		if (this.exportType == "lucid") {
			this.initiateOAuthExportToLucid(this.exportType,
				event.includeDeviceLabels, event.includeDeviceProperties,
				event.includeLinkLabels, event.includeLinkProperties,
				event.sheetsAcross, event.sheetsDown, event.vsdxFormat);
		}
		else {
			this.exportMap(this.exportType,
				event.includeDeviceLabels, event.includeDeviceProperties,
				event.includeLinkLabels, event.includeLinkProperties,
				event.sheetsAcross, event.sheetsDown, event.vsdxFormat);
		}
	}

	private exportMap(type: string,
		includeDeviceLabels: boolean, includeDeviceProperties: boolean,
		includeLinkLabels: boolean, includeLinkProperties: boolean,
		sheetsAcross: number, sheetsDown: number, vsdxFormat: boolean): void {
		let typeInfo = {
			"visio": { fileExt: (vsdxFormat ? ".vsdx" : ".vdx"), mimeType: "application/vnd.visio" },
			"pdf": { fileExt: ".pdf", mimeType: "application/pdf" },
			"svg": { fileExt: ".svg", mimeType: "image/svg+xml" },
		};

		let sessionGuid = this.identityService.sessionGuid;
		let netViewGuid = this.navService.location.netViewGuid;
		let agentGuid = this.navService.location.agentGuid;
		let schedDiscGuid = this.navService.location.schedDiscGuid;
		let schedDiscRsltGuid = this.navService.location.schedDiscRsltGuid;
		let vdgGuid = this.selectedDeviceGroup.VdgGuid;

		this.messageService.startWork();
		this.discResultsService.exportTopoMap(sessionGuid, netViewGuid, agentGuid,
			schedDiscGuid, schedDiscRsltGuid, vdgGuid, type, includeDeviceLabels,
			includeDeviceProperties, includeLinkLabels, includeLinkProperties,
			sheetsAcross, sheetsDown, vsdxFormat).subscribe(
				(result: Blob) => {
					this.messageService.endWork();
					let filename = this.selectedDeviceGroup.Name + typeInfo[type].fileExt;
					this.download(result, filename, typeInfo[type].mimeType);
				},
				(error) => {
					this.messageService.endWork();
					this.messageService.displayErrorMessage("Map export failed");
				});
	}

	private initiateOAuthExportToLucid(type: string,
		includeDeviceLabels: boolean, includeDeviceProperties: boolean,
		includeLinkLabels: boolean, includeLinkProperties: boolean,
		sheetsAcross: number, sheetsDown: number, vsdxFormat: boolean): void {

		let sessionGuid = this.identityService.sessionGuid;
		let netViewGuid = this.navService.location.netViewGuid;
		let agentGuid = this.navService.location.agentGuid;
		let schedDiscGuid = this.navService.location.schedDiscGuid;
		let schedDiscRsltGuid = this.navService.location.schedDiscRsltGuid;
		let vdgGuid = this.selectedDeviceGroup.VdgGuid;

		let localRedirectUrl = this.createLocalLucidRedirectUrl(type, includeDeviceLabels, includeDeviceProperties,
			includeLinkLabels, includeLinkProperties, sheetsAcross, sheetsDown, vsdxFormat, sessionGuid, netViewGuid,
			agentGuid, schedDiscGuid, schedDiscRsltGuid, vdgGuid);

		this.openInNewTab(localRedirectUrl);
	}

	private createInitiateLucidExportUrl(type: string, includeDeviceLabels: boolean, includeDeviceProperties: boolean,
		includeLinkLabels: boolean, includeLinkProperties: boolean, sheetsAcross: number, sheetsDown: number, vsdxFormat: boolean,
		sessionGuid: string, netViewGuid: string, agentGuid: string, schedDiscGuid: string,
		schedDiscRsltGuid: string, vdgGuid: string): string {

		let uriEncodedLocalRedirectUrl = this.createUriEncodedLocalLucidRedirectUrl(type, includeDeviceLabels, includeDeviceProperties,
			includeLinkLabels, includeLinkProperties, sheetsAcross, sheetsDown, vsdxFormat, sessionGuid, netViewGuid,
			agentGuid, schedDiscGuid, schedDiscRsltGuid, vdgGuid);

		return `${location.origin}/api/session/topomap/export/lucid/initiate?localRedirectUrl=${uriEncodedLocalRedirectUrl}`;
	}

	private createUriEncodedLocalLucidRedirectUrl(type: string, includeDeviceLabels: boolean, includeDeviceProperties: boolean,
		includeLinkLabels: boolean, includeLinkProperties: boolean, sheetsAcross: number, sheetsDown: number, vsdxFormat: boolean,
		sessionGuid: string, netViewGuid: string, agentGuid: string, schedDiscGuid: string,
		schedDiscRsltGuid: string, vdgGuid: string): string {

		let url = `${location.origin}/api/session/topomap/export/lucid?type=${type}&includeDeviceLabels=${includeDeviceLabels}` +
			`&includeDeviceProperties=${includeDeviceProperties}&includeLinkLabels=${includeLinkLabels}` +
			`&includeLinkProperties=${includeLinkProperties}&sheetsAcross=${sheetsAcross}&sheetsDown=${sheetsDown}&vsdxFormat=${vsdxFormat}` +
			`&sessionGuid=${sessionGuid}&netViewGuid=${netViewGuid}&agentGuid=${agentGuid}` +
			`&schedDiscGuid=${schedDiscGuid}&schedDiscRsltGuid=${schedDiscRsltGuid}&vdgGuid=${vdgGuid}`;

		return encodeURIComponent(url);
	}

	private createLocalLucidRedirectUrl(type: string, includeDeviceLabels: boolean, includeDeviceProperties: boolean,
		includeLinkLabels: boolean, includeLinkProperties: boolean, sheetsAcross: number, sheetsDown: number, vsdxFormat: boolean,
		sessionGuid: string, netViewGuid: string, agentGuid: string, schedDiscGuid: string,
		schedDiscRsltGuid: string, vdgGuid: string): string {

		return `${location.origin}/api/session/topomap/export/lucid?type=${type}&includeDeviceLabels=${includeDeviceLabels}` +
			`&includeDeviceProperties=${includeDeviceProperties}&includeLinkLabels=${includeLinkLabels}` +
			`&includeLinkProperties=${includeLinkProperties}&sheetsAcross=${sheetsAcross}&sheetsDown=${sheetsDown}&vsdxFormat=${vsdxFormat}` +
			`&sessionGuid=${sessionGuid}&netViewGuid=${netViewGuid}&agentGuid=${agentGuid}` +
			`&schedDiscGuid=${schedDiscGuid}&schedDiscRsltGuid=${schedDiscRsltGuid}&vdgGuid=${vdgGuid}`;
	}

	public displayLucidMap(value: boolean): void {
		this.lucidConfirmVisible = false;
		if (value) this.openInNewTab(this.lucidUrl);
		this.lucidUrl = "";
	}

	private openInNewTab(url): void {
		var win = window.open(url, '_blank');
		win.focus();
	}

	private download(data, filename, type): void {
		var file = (data instanceof Blob) ? data : new Blob([data], { type: type });
		var a = document.createElement("a");
		var url = URL.createObjectURL(file);
		a.href = url;
		a.download = filename;
		document.body.appendChild(a);
		a.click();
		setTimeout(function () {
			document.body.removeChild(a);
			window.URL.revokeObjectURL(url);
		}, 0);
	}

	// ── Layout ───────────────────────────────────────────────────────────────

	public startLayoutMap(): void {
		this.layoutSettings = new LayoutSettings();
		this.layoutSettingsVisible = true;
	}

	public layoutMap(): void {

		let sessionGuid = this.identityService.sessionGuid;
		let netViewGuid = this.navService.location.netViewGuid;
		let agentGuid = this.navService.location.agentGuid;
		let schedDiscGuid = this.navService.location.schedDiscGuid;
		let schedDiscRsltGuid = this.navService.location.schedDiscRsltGuid;
		let vdgGuid = this.selectedDeviceGroup.VdgGuid;

		let saveErrorMsg = "Save failed! Another user might be editing this map. Reload this page and try again.";
		this.discResultsService.layoutMap(sessionGuid, netViewGuid, agentGuid,
			schedDiscGuid, schedDiscRsltGuid, vdgGuid, this.layoutSettings).subscribe(
				(result: boolean) => {
					let loadErrorMsg = "Could not load updated map!";
					this.discResultsService.loadDeviceGroup(sessionGuid, netViewGuid, agentGuid,
						schedDiscGuid, schedDiscRsltGuid, vdgGuid).subscribe(
							(result: boolean) => { /* nothing to do */ },
							(error) => { this.messageService.displayErrorMessage(loadErrorMsg); });
				},
				(error) => { this.messageService.displayErrorMessage(saveErrorMsg); });
	}

	public setAsRoot(): void {
		this.setRoot("set-as-root", this.contextMenuTargets[0].nodeId);
	}

	public autoSelectRoot(): void {
		this.setRoot("auto-select-root", this.contextMenuTargets[0].nodeId);
	}

	public layoutChildren(): void {
		this.setRoot("layout-children", this.contextMenuTargets[0].nodeId);
	}

	private setRoot(operation: string, nodeId: number): void {

		let sessionGuid = this.identityService.sessionGuid;
		let netViewGuid = this.navService.location.netViewGuid;
		let agentGuid = this.navService.location.agentGuid;
		let schedDiscGuid = this.navService.location.schedDiscGuid;
		let schedDiscRsltGuid = this.navService.location.schedDiscRsltGuid;
		let vdgGuid = this.selectedDeviceGroup.VdgGuid;

		let saveErrorMsg = "Save failed! Another user might be editing this map. Reload this page and try again.";
		this.discResultsService.setMapRoot(sessionGuid, netViewGuid, agentGuid,
			schedDiscGuid, schedDiscRsltGuid, vdgGuid, operation, nodeId).subscribe(
				(result: boolean) => {
					let loadErrorMsg = "Could not load updated map!";
					this.discResultsService.loadDeviceGroup(sessionGuid, netViewGuid, agentGuid,
						schedDiscGuid, schedDiscRsltGuid, vdgGuid).subscribe(
							(result: boolean) => { /* nothing to do */ },
							(error) => { this.messageService.displayErrorMessage(loadErrorMsg); });
				},
				(error) => { this.messageService.displayErrorMessage(saveErrorMsg); });
	}

	// ── Offcanvas ────────────────────────────────────────────────────────────

	private openOffcanvas(): void {
		this.offcanvasService.open(this.detailsOffCanvas, { ariaLabelledBy: 'offcanvas-basic-title', position: 'bottom' }).result.then(
			(result) => { },
			(reason) => { },
		);
	}

	public onOffcanvasClose(): void {
		this.selectedDevice = null;
		this.selectedLinks = [];
	}

	// ── Search ───────────────────────────────────────────────────────────────

	public onSearchDeviceSelected(device: DeviceNode): void {
		this.showDeviceOnMap(device.deviceGuid);
	}

	// ── Context menu — device actions ────────────────────────────────────────

	private showDeviceProperties(deviceGuid: string): void {
		this.onDeviceDoubleClick(deviceGuid);
	}

	private showInIntegration(_integration: string, _deviceGuid: string): void {
		// TODO: look up device in the named integration and open the URL
	}

	private linkDevices(_nodes: DeviceNode[]): void {
		// TODO: open Link Devices dialog (manual link creation)
	}

	private removeSelectedDevices(_nodes: DeviceNode[]): void {
		// TODO: remove the given nodes from the map via server API
	}

	// ── Context menu — link actions ───────────────────────────────────────────

	private showLinkProperties(links: DeviceLink[]): void {
		this.onLinkDoubleClick(links);
	}

	private unlinkDevices(_links: DeviceLink[]): void {
		// TODO: remove manual link via server API
	}

	// ── Context menu — map actions ────────────────────────────────────────────

	public selectAssignedRoots(): void {
		const map = this.topoMapControl?.getMap();
		if (!map) return;
		const rootGuids = new Set((map.layoutSettings.rootNodes ?? []).map(r => r.deviceGuid));
		map.deviceNodes.forEach(n => n.selected = rootGuids.has(n.deviceGuid));
		map.deviceGroupNodes.forEach(n => n.selected = false);
		this.topoMapControl.redraw();
	}

	public onAddDevicesRequested(): void {
		// TODO: open Add Devices dialog via server API
	}

	public onRemoveDevicesRequested(_nodes: DeviceNode[]): void {
		// TODO: remove devices from map via server API
	}

	private addConnectedDevices(_category: string): void {
		// TODO: add connected devices of the given category via server API
	}

	private addAssociatedDevices(_category: string): void {
		// TODO: add associated devices of the given category via server API
	}

	private removeConnectedDevices(_category: string): void {
		// TODO: remove connected devices of the given category via server API
	}

	private removeAssociatedDevices(_category: string): void {
		// TODO: remove associated devices of the given category via server API
	}

}
